type TJsonData = {
    dayNumber?: number;
    xshortName?: string;
    shortName?: string;
    mediumName?: string;
    longName?: string;
};
class NamedWeek {
    dayNumber: number;
    xShortName: string;
    shortName: string;
    mediumName: string;
    longName: string;

    constructor(jsonData: TJsonData) {
        this.dayNumber = 0;
        this.xShortName = "";
        this.shortName = "";
        this.mediumName = "";
        this.longName = "";
        if (jsonData) {
            this.dayNumber = jsonData.dayNumber || 0;
            this.xShortName = jsonData.xshortName || "";
            this.shortName = jsonData.shortName || "";
            this.mediumName = jsonData.mediumName || "";
            this.longName = jsonData.longName || "";
        }
    }

    toJson(namedWeeks: NamedWeek[]) {
        const jsonArray: (string | number)[][] = [];
        // dayNumbers
        jsonArray.push(namedWeeks.map((namedWeek) => namedWeek.dayNumber));
        // xshortNames
        jsonArray.push(namedWeeks.map((namedWeek) => namedWeek.xShortName));
        // shortNames
        jsonArray.push(namedWeeks.map((namedWeek) => namedWeek.shortName));
        // mediumNames
        jsonArray.push(namedWeeks.map((namedWeek) => namedWeek.mediumName));
        // longNames
        jsonArray.push(namedWeeks.map((namedWeek) => namedWeek.longName));
        return jsonArray;
    }

    getLongestName() {
        if (this.longName !== "") {
            return this.longName;
        }
        if (this.mediumName !== "") {
            return this.mediumName;
        }
        if (this.shortName !== "") {
            return this.shortName;
        }
        return this.xShortName;
    }

    getShortestName() {
        if (this.xShortName !== "") {
            return this.xShortName;
        }
        if (this.shortName !== "") {
            return this.shortName;
        }
        if (this.mediumName !== "") {
            return this.mediumName;
        }
        return this.longName;
    }

    isEmpty() {
        return (
            this.xShortName === "" &&
            this.shortName === "" &&
            this.mediumName === "" &&
            this.longName === ""
        );
    }

    static create = (jsonDataArray: TJsonData[]) =>
        jsonDataArray.map((jsonData) => new NamedWeek(jsonData));
}

export default NamedWeek;
